var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading !== 0 && _vm.isLoading !== false)?_c('div',{class:[
    'm-loading-wrap',
    {
      'm-loading-wrap__center' : _vm.center,
      'm-loading-wrap__full' : _vm.full
    }
  ]},[(_vm.isLoading !== -1)?_c('div',{staticClass:"m-loading"},[_c('div',{staticClass:"loading"},[_c('img',{style:({width: '75px'}),attrs:{"src":require('@/assets/img/loading.png')}})]),(_vm.isLoading === -1)?_c('div',{staticClass:"loading-fail"},[_c('p',{staticClass:"fail-text"},[_vm._v(" Data failed loading. Please reload. ")]),_c('div',{staticClass:"fail-btn",on:{"click":_vm.fail}},[_vm._v(" Reload ")])]):_vm._e()]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }